var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTdaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.8 156.4",
    width: 50,
    height: 50,
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".tda{fill:#30b457}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tda",
    d: "M0 156.4h174.8V0H0v156.4zm114.8-33.9H74V49.2h20.5v60.4h19.7c13.6 0 19.3-9.4 19.3-33.6 0-24.4-6.5-31.5-20.3-31.5H68.3v78.1H48.1V44.4H18.4v-13h101.1c24.4 0 36 12.6 36 44.3 0 41.7-17.3 46.8-40.7 46.8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdaLogo);
export default __webpack_public_path__ + "static/media/tda-logo.80e7029a39e9374f4e724204e57913ab.svg";
export { ForwardRef as ReactComponent };